import React, {Component, PropTypes} from 'react';
import {Button} from 'react-bootstrap';
import moment from 'moment';
import { MATCH_TOTAL } from '../../constants';

import ReactTable from 'react-table';

import {filterableBooleanCell, includesInsensitive, defaultFilterMethod} from 'utils/table';

export default class MatchesList extends Component {
  render() {
    const {
      isUpdating,
      all: matches,
      toggleMatchApproved,
      selectOne,
    } = this.props;

    const columns = [
      {
        Header: '#',
        filterable: false,
        accessor: 'index',
        Cell: props => props.value+'.',
        maxWidth: 80
      },
      {
        Header: 'Score',
        accessor: 'score',
        Cell: props => {
          return ((props.value/MATCH_TOTAL*100).toFixed() + '%');
        },
        filterMethod: (filter, row) => {
          return row[filter.id] > filter.value;
        }
      },
      {
        id: 'name',
        Header: 'Candidate',
        accessor: ({candidate}) => ({
          name: `${candidate.brief.lastName}, ${candidate.brief.firstName}`,
          url: candidate.socialMedia && candidate.socialMedia.linkedInUrl
        }),
        filterMethod: (filter, row) => {
          return includesInsensitive(row[filter.id].name, filter.value)
        },
        Cell: props => {
          const {value: {url, name}} = props
          if(url) {
            return <a href={url} target="_blank">{name}</a>
          }else{
            return <span>{name}</span>
          }
        }
      },
      {
        id: 'companyName', // Required because our accessor is not a string
        Header: 'Company',
        accessor: ({company}) => ({
          name:company.brief.name,
          url:company.brief.socialMedia && company.brief.socialMedia.websiteUrl
        }),
        filterMethod: (filter, row) => {
          return includesInsensitive(row[filter.id].name, filter.value);
        },
        Cell: props => {
          const {value: {url, name}} = props
          if(url) {
            return <a href={url} target="_blank">{name}</a>
          }else{
            return <span>{name}</span>
          }
        }
      },
      {
        Header: 'Vacancy',
        accessor: 'vacancy.brief.title'
      },
      {
        id: 'status', // Required because our accessor is not a string
        Header: 'Status',
        sortable: false,
        filterable: false,
        accessor: ({candidate,vacancy}) => ({
          candidate,vacancy
        }),
        Cell: props => {
          const {value:{candidate, vacancy}} = props
          return <Status candidate={candidate} vacancy={vacancy}/>
        }
      },
      {
        Header: 'Approved',
        accessor: 'isApproved',
        ...filterableBooleanCell
      },
      {
        id: 'actions',
        Header: 'Actions',
        sortable: false,
        filterable: false,
        accessor: match => (
          <Button onClick={selectOne(match._id)}>
            View Details
          </Button>
        )
      }
    ];

    const matchesIndexed = matches && matches.map((el,index) => ({index:index+1, ...el})) //immutable

    return (
      <ReactTable
        loading={isUpdating || !matches}
        data={matchesIndexed}
        columns={columns}
        defaultFilterMethod={defaultFilterMethod}
        filterable
      />
    );
  }
}

const Status =  (props) => {
  const {vacancy, candidate} = props
  return (
    <div style={{fontSize: 12}}>
      vacancy is{' '}
      <strong>
        {vacancy.status == 'new' ? 'not yet considered' : vacancy.status}
      </strong>{' '}
      by candidate
      <br />
      <br />
      candidate is{' '}
      <strong>
        {candidate.status == 'new'
          ? 'not yet considered'
          : candidate.status}
      </strong>{' '}
      for vacancy
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/matches/DataGrid.jsx